import { EntityType } from '../services/entities/entity-type.class';
import { Entity } from './entity.class';
import { PlanningDayItem } from './planning-day-item.class';

export class Entities {
    public entity: Entity;
    public entitytype: EntityType;
    public items: PlanningDayItem[] = [];
    public unavailableDays: number;
}
